export const scrollToElement = (selector, options = {}) => {
    const element = document.querySelector(selector);
    element?.scrollIntoView({ behavior: 'smooth', block: "center", ...options });
  };
